import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';
import LocalizationUIAssets from '../Localization-UIAssets';

export default class TitleScreen extends Phaser.Scene {
  static get KEY() { return 'TitleScreen'; }

  constructor() {
    super({ key: TitleScreen.KEY });
  }

  create() {
    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    this.background = ABCyaPhaser.Images.addImage(0, 0, 'background', this).setOrigin(0);

    this.title = ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, LocalizationUIAssets._title, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

    ABCyaPhaser.Tweens.addTween(this.title, 2000, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {
      this.scene.start(Game.KEY);
    });
  }
}